
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type dialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function dialogRT(): TemplateResult<dialogRTRootProps> {
    function scopeGarageSize1() {
        var garageSize = this.garageSize;
        return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
            'className': 'close',
            'onClick': this.close
        }, _createElement('svg', {
            'className': 'cm_icon cm_icon-times',
            'height': '20px',
            'role': 'img',
            'viewBox': '0 0 22 22'
        }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))), _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-body' }, _createElement('div', { 'className': 'dialog-body-content' }, _createElement('div', { 'className': 'dialog-body-vehicle-widget' }, _createElement('div', { 'className': 'dialog-body-vehicle-widget-titles' }, _createElement('div', { 'className': 'dialog-body-vehicle-widget-title' }, _translate(`garage_your_models`)), _createElement('div', { 'className': 'dialog-body-vehicle-widget-subtitle' }, _translate(`garage_max_capacity`))), [this.vehicleWidget(function () {
                function repeatSelects1(selects, selectsIndex) {
                    return [selects(function () {
                            function repeatEntry1(entry, entryIndex) {
                                return _createElement('option', {
                                    'disabled': this.loading,
                                    'value': entry.term,
                                    'key': entry.value
                                }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                            }
                            return _createElement('div', { 'className': this.extraClassName }, _createElement('div', { 'className': 'cm_select_native-container' }, _createElement('select', {
                                'className': 'cm_select_inner-select ' + (this.firstSelectedTerm ? 'cm_selected' : ''),
                                'onChange': this.onChange,
                                'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                                'disabled': this.disabled,
                                'aria-label': this.title
                            }, this.useNativeDropdown ? [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                _map(this.entries, repeatEntry1.bind(this))
                            ] : null)));
                        }, { count: undefined })];
                }
                return _createElement('div', { 'className': 'cm_HeaderVehicleWidget_garage cm_HeaderVehicleWidget_verify cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicleWidget' }, _createElement('div', { 'className': 'cmTemplate_active cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, _translate(`garage_add_button`)), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                    'div',
                    { 'className': 'cm_vehicle-widget_select-container' + (garageSize >= 5 ? ' cm_disabled' : '') + '  cmRepeater_selects' },
                    _map(this.selects, repeatSelects1.bind(this))
                ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                    'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
                    'onClick': this.selectVehicle,
                    'disabled': !this.allowToSetVehicle || garageSize >= 5,
                    'role': 'button',
                    'tabIndex': this.allowToSetVehicle ? '0' : '-1'
                }, '\n                    ', _translate(`garage_add_model`), '\n                  ')))), garageSize >= 5 ? _createElement('div', {
                    'className': 'dialog-body-vehicle-widget-message',
                    'key': '2580'
                }, _createElement('div', { 'className': 'dialog-body-vehicle-widget-message-title' }, _translate(`garage_limit_title`)), '\n              ', _translate(`garage_limit_message`), '\n            ') : null);
            }, {
                widgetName: 'undefined',
                items: undefined
            })]), [this.vehicleList(function () {
                function repeatItems1(currentVehicle, items, itemsIndex) {
                    return [items(function () {
                            return !window.Convermax.isCurrentVehicle(this.vehicle, currentVehicle) ? _createElement('div', {
                                'className': 'dialog-body-garage-item',
                                'onClick': this.selectVehicle,
                                'key': '21'
                            }, _createElement('div', { 'className': 'cm_checkbox' }, [_createElement('svg', {
                                    'className': 'cm_unchecked',
                                    'width': '1.6rem',
                                    'height': '1.6rem',
                                    'viewBox': '0 0 16 16',
                                    'aria-hidden': 'true',
                                    'focusable': 'false',
                                    'key': '2350'
                                }, _createElement('rect', {
                                    'x': '1',
                                    'y': '1',
                                    'width': '14',
                                    'height': '14',
                                    'stroke': 'currentColor',
                                    'fill': 'none',
                                    'strokeWidth': '1',
                                    'vectorEffect': 'non-scaling-stroke'
                                }))]), _createElement('div', { 'className': 'dialog-body-garage-content' }, _createElement('div', { 'className': 'dialog-body-garage-item-type' }, this.vehicle.Type, ' / ', this.vehicle.Make), _createElement('div', { 'className': 'dialog-body-garage-item-model' }, this.vehicle.Model)), _createElement('span', {
                                'className': 'dialog-body-garage-item-remove-model',
                                'onClick': this.removeVehicle
                            }, [_createElement('svg', {
                                    'xmlns': 'http://www.w3.org/2000/svg',
                                    'width': '20',
                                    'height': '20',
                                    'viewBox': '0 0 20 20',
                                    'fill': 'none',
                                    'key': '9700'
                                }, _createElement('path', {
                                    'd': 'M2.5 5H17.5',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M15.8327 5V16.6667C15.8327 17.5 14.9993 18.3333 14.166 18.3333H5.83268C4.99935 18.3333 4.16602 17.5 4.16602 16.6667V5',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M6.66602 5.00008V3.33341C6.66602 2.50008 7.49935 1.66675 8.33268 1.66675H11.666C12.4993 1.66675 13.3327 2.50008 13.3327 3.33341V5.00008',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M8.33398 9.16675V14.1667',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }), _createElement('path', {
                                    'd': 'M11.666 9.16675V14.1667',
                                    'stroke': 'black',
                                    'strokeLinecap': 'round',
                                    'strokeLinejoin': 'round'
                                }))])) : null;
                        }, { count: undefined })];
                }
                function scopeCurrentVehicle2() {
                    var currentVehicle = this.vehicle;
                    return _createElement('div', { 'className': 'dialog-body-garage-other-vehicles' }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cmRepeater_items' },
                        _map(this.items, repeatItems1.bind(this, currentVehicle))
                    ]));
                }
                return _createElement('div', { 'className': 'cm_VehicleDialogList_garage cm_VehicleDialogList_verify dialog-body-garage cm_garage cm_garage__dialog cm_vehicleList' }, _createElement('div', { 'className': 'cm_garageDropdown' }, _createElement('div', { 'className': 'dialog-body-garage-titles' }, _createElement('div', { 'className': 'dialog-body-garage-title' }, _translate(`garage_current_vehicle`)), _createElement('div', { 'className': 'dialog-body-garage-subtitle' }, !this.isVehicleSelected ? [
                    ' ',
                    _translate(`garage_empty_title`),
                    ' '
                ] : null, this.isVehicleSelected ? [
                    '\n                  ',
                    _translate(`garage_selected_vehicle_title`),
                    '\n                '
                ] : null), this.isVehicleSelected ? _createElement('div', {
                    'className': 'dialog-body-garage-current-vehicle',
                    'key': '681'
                }, _createElement('div', { 'className': 'dialog-body-garage-item' }, _createElement('div', { 'className': 'cm_checkbox' }, [_createElement('svg', {
                        'className': 'cm_checked icon icon-checkmark',
                        'aria-hidden': 'true',
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '22',
                        'height': '23',
                        'viewBox': '0 0 22 23',
                        'fill': 'none',
                        'key': '8790'
                    }, _createElement('path', {
                        'd': 'M18.3327 5.82227L8.24935 15.9056L3.66602 11.3223',
                        'stroke': 'white',
                        'strokeWidth': '1.3',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))]), _createElement('div', { 'className': 'dialog-body-garage-content' }, _createElement('div', { 'className': 'dialog-body-garage-item-type' }, this.vehicle.Type, ' / ', this.vehicle.Make), _createElement('div', { 'className': 'dialog-body-garage-item-model' }, this.vehicle.Model)), _createElement('span', {
                    'className': 'dialog-body-garage-item-remove-model',
                    'onClick': this.removeVehicle
                }, [_createElement('svg', {
                        'xmlns': 'http://www.w3.org/2000/svg',
                        'width': '20',
                        'height': '20',
                        'viewBox': '0 0 20 20',
                        'fill': 'none',
                        'key': '16370'
                    }, _createElement('path', {
                        'd': 'M2.5 5H17.5',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M15.8327 5V16.6667C15.8327 17.5 14.9993 18.3333 14.166 18.3333H5.83268C4.99935 18.3333 4.16602 17.5 4.16602 16.6667V5',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M6.66602 5.00008V3.33341C6.66602 2.50008 7.49935 1.66675 8.33268 1.66675H11.666C12.4993 1.66675 13.3327 2.50008 13.3327 3.33341V5.00008',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M8.33398 9.16675V14.1667',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }), _createElement('path', {
                        'd': 'M11.666 9.16675V14.1667',
                        'stroke': 'black',
                        'strokeLinecap': 'round',
                        'strokeLinejoin': 'round'
                    }))]))) : null), !this.isEmpty ? _createElement('div', {
                    'className': 'cmTemplate_list',
                    'key': '2552'
                }, _createElement('div', { 'className': 'dialog-body-garage-titles vehicles-list' }, _createElement('div', { 'className': 'dialog-body-garage-title' }, _translate(`garage_your_other_vehicles`)), _createElement('div', { 'className': 'dialog-body-garage-subtitle' }, _translate(`garage_other_stored_vehicles`)), scopeCurrentVehicle2.apply(this, []))) : null));
            }, {
                widgetName: 'undefined',
                items: undefined
            })]))));
    }
    return scopeGarageSize1.apply(this, []);
}
        export const componentNames = ["cm:vehicleWidget","cm:vehicleList"]